export default "__VITE_PUBLIC_ASSET__ad45d295__"